import React from 'react';
import { Layout } from '../components/layout/Layout';
import { LogsViewer } from '../components/config/LogsViewer';

export const LogsViewerPage: React.FC = () => {
  return (
    <Layout>
      <LogsViewer />
    </Layout>
  );
};
